export interface Cell {
  x: number;
  y: number;
}

export interface Shape {
  name: string;
  cells: Cell[];
}

export interface Piece {
  id: number;
  shape: Shape;
  color: string;
  cells: Cell[];
  canMoveTo(board: (number | null)[][], dx: number, dy: number): boolean;
  moveTo(dx: number, dy: number): void;
  getBottomY(): number;
}

export interface GameState {
  board: (number | null)[][];
  pieces: Map<number, Piece>;
  selected: number | null;
  moves: number;
  level: number;
  animating: boolean;
  processingCascades: boolean;
  score: number;
  combo: number;
  corruptionLevel: number;
  gameOver: boolean;
  timeRemaining: number;
  lastMoveTime: number;
  fallingPieces: Set<number>; // Pieces currently falling
  lastFallTime: number; // Last time pieces fell one row
  fallSpeed: number; // Milliseconds between falls
}

export interface GameConfig {
  cols: number;
  rows: number;
  cellSize: number;
}

export const GAME_EVENTS = {
  PIECE_SELECTED: 'piece:selected',
  PIECE_REMOVED: 'piece:removed',
  LEVEL_COMPLETE: 'level:complete',
  LINE_CLEARED: 'line:cleared',
  GRAVITY_APPLIED: 'gravity:applied',
  CORRUPTION_RISE: 'corruption:rise',
  GAME_OVER: 'game:over',
  SCORE_UPDATE: 'score:update',
  COMBO_UPDATE: 'combo:update',
  TIME_UPDATE: 'time:update',
  NEW_PIECE_SPAWNED: 'piece:spawned',
} as const;

export type GameEvent = typeof GAME_EVENTS[keyof typeof GAME_EVENTS];